/* eslint-disable react/no-unescaped-entities */
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import Container from "~franchise-website/common/Container";

const CaseStudyTwo = () => {
	const theme = useTheme();

	return (
		<Box
			borderRadius={1.5}
			sx={{
				position: "relative",
				backgroundColor: theme.palette.alternate.main,
				"&::after": {
					position: "absolute",
					content: '""',
					width: "30%",
					zIndex: 1,
					top: 0,
					right: 0,
					height: "100%",
					backgroundSize: "18px 18px",
					backgroundImage: `radial-gradient(${theme.palette.primary.light} 20%, transparent 20%)`,
					opacity: 0.2,
				},
			}}>
			<Container
				position="relative"
				zIndex={2}
				paddingX={{ xs: 2, sm: 6, md: 12 }}>
				<Box>
					<Box
						component="ul"
						display="flex"
						justifyContent="flex-start"
						width="100%">
						<Box
							component={ListItem}
							disableGutters
							width="auto">
							<ListItemAvatar>
								<Avatar src="/app-assets/images/customer-littlelearnersicon.png" />
							</ListItemAvatar>
							<ListItemText
								primary="Charlotte Saunders"
								secondary="Little Learners"
							/>
						</Box>
					</Box>
					<Typography
						variant="h2"
						gutterBottom
						align="left">
						<Box
							fontWeight={700}
							component="span">
							&ldquo;The Mango team is always around and willing to help and we
							couldn't be happier that we are customers. We would recommend them
							to anyone looking for this software.&rdquo;
						</Box>
					</Typography>

					<Box
						component={Typography}
						variant="h6"
						fontWeight={400}
						align="center"
						gutterBottom
					/>
				</Box>
			</Container>
		</Box>
	);
};

export default CaseStudyTwo;
